var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',[_c('video-header',{on:{"title-search":_vm.toChildMsg}})],1),_vm._v(" "),_c('el-main',[_c('div',{staticClass:"rule",domProps:{"innerHTML":_vm._s(_vm.content)}})]),_vm._v(" "),_c('el-footer',[_c('app-footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30083fab","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/filerule/index.vue
// module id = null
// module chunks = 